import React from 'react';
import { LoadingCommonProps, LoadingSpinner } from './';

export interface LoadingProps extends LoadingCommonProps {
  size?: number;
  full?: boolean;
}
const Loading: React.FunctionComponent<LoadingProps> = ({ loading = false, type, size, style, full }) =>
  loading ? (
    <div
      data-testid="loading-indicator"
      style={
        full
          ? {
              ...style,
              ...{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              },
            }
          : style
      }
    >
      <LoadingSpinner type={type} size={size} />
    </div>
  ) : null;

export default Loading;
